module.exports = __webpack_public_path__ + "img/logo.287ebfda.png";